export enum DecisionSupportStatus {
  ERROR = 'error',
  GENERATING = 'generating',
  GENERATED = 'generated'
}

export enum DecisionSupportSource {
  DECISION_SUPPORT = 'decisionSupport'
}
